import makeButton from './utils/makeButton';
import StyledAnchor from './styled/StyledAnchor';
import StyledButton from './styled/StyledButton';

const Button = makeButton(StyledButton, StyledAnchor);

Button.displayName = 'Button';

export default Button;
